import { render, staticRenderFns } from "./FreelancerCard.htm?vue&type=template&id=5ff5bc6d&scoped=true&"
import script from "./FreelancerCard.ts?vue&type=script&lang=js&"
export * from "./FreelancerCard.ts?vue&type=script&lang=js&"
import style0 from "./FreelancerCard.scss?vue&type=style&index=0&id=5ff5bc6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5bc6d",
  null
  
)

export default component.exports